/* Plot & Harvest product page (v1 3-10-2026): gallery, options, basket, fit planner, tabs, spec highlight */
(function () {
  'use strict';
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }

  $$('[data-ph-pdp]').forEach(function (root) {
    /* ---- gallery ---- */
    var slides = $$('[data-gal-slide]', root), thumbs = $$('[data-gal-go]', root), cur = 0;
    function go(i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== cur; });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-selected', k === cur ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-gal-go')); }); });
    $$('[data-gal-step]', root).forEach(function (b) { b.addEventListener('click', function () { go(cur + +b.getAttribute('data-gal-step')); }); });
    var main = $('.ph-gal__main', root), sx = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); sx = null; });
    }

    /* ---- options → variant ---- */
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', root).textContent); } catch (e) {}
    var groups = $$('[data-opt]', root);
    var idIn = $('[data-variant-id]', root), priceEl = $('[data-price]', root), basisEl = $('[data-basis-line]', root);
    var add = $('[data-add]', root), askP = $('[data-ask-product]', root);
    var current = variants.filter(function (x) { return idIn && String(x.id) === idIn.value; })[0] || variants[0];
    function chosen() {
      var o = current ? current.o.slice() : [];
      groups.forEach(function (g) { var c = $('input:checked', g); if (c) o[+g.getAttribute('data-opt')] = c.value; });
      return o;
    }
    function highlightSpecs() {
      var t = current ? current.t.toLowerCase() : '';
      $$('[data-spec-key]', root).forEach(function (c) { var k = c.getAttribute('data-spec-key'); c.classList.toggle('is-on', !!k && t.indexOf(k) >= 0); });
    }
    function update() {
      var o = chosen();
      var v = variants.filter(function (x) { return x.o.every(function (val, i) { return val === o[i]; }); })[0];
      if (!v) { if (add) { add.disabled = true; add.textContent = 'Unavailable'; } return; }
      current = v;
      if (idIn) idIn.value = v.id;
      if (priceEl) priceEl.textContent = v.p;
      if (add) { add.disabled = !v.a; add.textContent = v.a ? 'Add to basket' : 'Sold out'; }
      var c = groups.length === 1 ? $('input:checked', groups[0]) : null, b = c ? c.getAttribute('data-basis') : '';
      if (basisEl) { basisEl.hidden = !b; basisEl.textContent = b ? 'Set: ' + b : ''; }
      if (askP) askP.value = askP.value.replace(/\s*\(.*\)$/, '') + (v.t && v.t !== 'Default Title' ? ' (' + v.t + ')' : '');
      if (v.m) { var k = slides.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(v.m)); if (k >= 0) go(k); }
      highlightSpecs();
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }
    groups.forEach(function (g) { g.addEventListener('change', update); });
    highlightSpecs();

    /* ---- quantity ---- */
    var q = $('[data-qty-input]', root);
    $$('[data-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () { var n = (parseInt(q.value, 10) || 1) + +b.getAttribute('data-qty'); q.value = Math.max(1, n); });
    });
    if (q) q.addEventListener('change', function () { q.value = Math.max(1, parseInt(q.value, 10) || 1); });

    /* ---- add to basket (AJAX, normal submit as fallback) ---- */
    var form = $('[data-buy-form]', root), msg = $('[data-buy-msg]', root);
    if (form && window.fetch && window.FormData) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var label = add.textContent, base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        add.disabled = true; add.textContent = 'Adding…';
        fetch(base + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { return fetch(base + 'cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            msg.hidden = false; msg.className = 'ph-buy__msg'; msg.innerHTML = 'Added to your basket. <a href="' + base + 'cart">View basket</a>';
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ph-pdp', data: { itemCount: cart.item_count, source: 'ph-pdp' } } }));
          })
          .catch(function (err) {
            msg.hidden = false; msg.className = 'ph-buy__msg is-err';
            msg.textContent = (err && (err.description || err.message)) || 'Could not add this item. Please try again.';
          })
          .then(function () { add.disabled = false; add.textContent = label; });
      });
    }

    /* ---- fit planner ---- */
    var fit = $('[data-fit]', root);
    if (fit) {
      var T = +fit.getAttribute('data-table'), CW = +fit.getAttribute('data-cw'), CD = +fit.getAttribute('data-cd'), CL = +fit.getAttribute('data-clear');
      var inL = $('[data-fit-l]', fit), inD = $('[data-fit-d]', fit), svg = $('[data-fit-svg]', fit), out = $('[data-fit-verdict]', fit);
      var needL = 2 * CD + T, needD = Math.max(T, CW);
      var r1 = function (n) { return Math.round(n * 10) / 10; };
      var note = $('.ph-fit__note', fit);
      if (note) note.textContent = 'Laid out as: table in the middle, a chair either side. Seated footprint ' + r1(needL) + ' × ' + r1(needD) + ' cm; we allow a further ' + r1(CL) + ' cm at each end to get in and out.';
      function draw() {
        var L = Math.max(0, parseFloat(inL.value) || 0), D = Math.max(0, parseFloat(inD.value) || 0);
        var W = 400, H = 260, pad = 26;
        var spanL = Math.max(L, needL), spanD = Math.max(D, needD);
        var sc = Math.min((W - 2 * pad) / spanL, (H - 2 * pad) / spanD);
        var cx = W / 2, cy = H / 2, h = '';
        if (L && D) {
          h += '<rect x="' + (cx - L * sc / 2) + '" y="' + (cy - D * sc / 2) + '" width="' + L * sc + '" height="' + D * sc + '" fill="#faf7ee" stroke="#b9a77a" stroke-width="1.5" stroke-dasharray="6 5" rx="2"/>';
          h += '<text x="' + cx + '" y="' + (cy - D * sc / 2 - 8) + '" text-anchor="middle" font-size="11" fill="#5f675f" font-family="Inter, sans-serif">' + r1(L) + ' cm</text>';
          h += '<text x="' + (cx + L * sc / 2 + 6) + '" y="' + (cy + 4) + '" font-size="11" fill="#5f675f" font-family="Inter, sans-serif">' + r1(D) + '</text>';
        }
        var cw = CW * sc, cd = CD * sc, t = T * sc;
        h += '<rect x="' + (cx - t / 2 - cd) + '" y="' + (cy - cw / 2) + '" width="' + cd + '" height="' + cw + '" fill="#8fa898" rx="3"/>';
        h += '<rect x="' + (cx + t / 2) + '" y="' + (cy - cw / 2) + '" width="' + cd + '" height="' + cw + '" fill="#8fa898" rx="3"/>';
        h += '<circle cx="' + cx + '" cy="' + cy + '" r="' + t / 2 + '" fill="#1f3a2c"/>';
        svg.innerHTML = h;
        var cls = '', b, sTxt;
        if (L >= needL + 2 * CL && D >= needD) { b = 'Fits comfortably'; sTxt = 'Room for both chairs pulled out and space to stand up at each end.'; }
        else if (L >= needL && D >= needD) { cls = 'is-tight'; b = 'Fits, but it’s snug'; sTxt = 'The set fits with the chairs pulled out, but there’s less than ' + CL + ' cm at each end to get in and out.'; }
        else { cls = 'is-no'; b = 'Too small for the set'; sTxt = 'You need at least ' + r1(needL) + ' × ' + r1(needD) + ' cm with the chairs pulled out (' + r1(needL + 2 * CL) + ' cm long to stand up comfortably).'; }
        out.className = 'ph-fit__verdict ' + cls;
        $('b', out).textContent = b; $('span', out).textContent = sTxt;
      }
      inL.addEventListener('input', draw); inD.addEventListener('input', draw);
      draw();
    }

    /* ---- on-page tabs: highlight the section in view ---- */
    var links = $$('[data-tabs] a', root);
    if (links.length && 'IntersectionObserver' in window) {
      var map = {};
      links.forEach(function (a) { var id = a.getAttribute('href').slice(1), el = document.getElementById(id); if (el) map[id] = a; });
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) { a.removeAttribute('aria-current'); });
          var a = map[e.target.id]; if (a) a.setAttribute('aria-current', 'true');
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
    }

    /* ---- question form: after sending, bring the result into view ---- */
    var st = $('[data-ask-status]', root);
    if (st) { var sec = st.closest('.ph-qa'); if (sec) sec.scrollIntoView(); st.focus({ preventScroll: true }); }
  });
})();
